import {Component, Input} from '@angular/core';
import {TicketChangeHistory} from '@app/shared/services';
import {AppConstants} from '@app/shared/util/app-constants';

@Component({
  selector: 'app-ticket-change-history-author-logo',
  templateUrl: './ticket-change-history-author-logo.component.html',
  styleUrls: ['./ticket-change-history-author-logo.component.scss'],
  standalone: false
})
export class TicketChangeHistoryAuthorLogoComponent {

  @Input() changeHistory: TicketChangeHistory;
  @Input() fontSize = AppConstants.DEFAULT_COMMENT_LOGO_FONT_SIZE;

  readonly DEFAULT_LOGO_URL = AppConstants.DEFAULT_LOGO_URLS['90x40'];
  readonly CIM_COMPANY_NAME = AppConstants.CIM_COMPANY_NAME;

  constructor() {}

}
